import clsx from 'clsx'

import { formatPrice } from '@/shared/lib/utils/price/format-price'

import cl from './price.module.scss'

interface ProductPriceProps {
	className?: string
	price: number
	isOld?: boolean
}

export const Price = (props: ProductPriceProps) => {
	const { className, price, isOld = 0 } = props

	const formattedPrice = formatPrice(price)

	if (isOld) {
		return <div className={clsx(cl.old, className)}>{formattedPrice}</div>
	}

	return <div className={clsx(cl.current, className)}>{formattedPrice}</div>
}
